import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { EventService } from '@share/services/event.service';
import { BlockEvent } from '@share/models/block-event';


export const eventResolver: ResolveFn<BlockEvent | null> = (route) => {
  const eventService = inject(EventService);  
  const idParam = route.paramMap.get('eventId');

  const id = idParam ? Number(idParam) : NaN;

  if (!Number.isFinite(id) || !Number.isInteger(id) || id < 0) {
    return of(null);
  }

  return eventService.getEventById(id).pipe(
    catchError(() => of(null))
  );
};

